/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Query_Column_OrderInputs */

const en_ledger_query_column_order = /** @type {(inputs: Ledger_Query_Column_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Column order`)
};

const nl_ledger_query_column_order = /** @type {(inputs: Ledger_Query_Column_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolomvolgorde`)
};

/**
* | output |
* | --- |
* | "Column order" |
*
* @param {Ledger_Query_Column_OrderInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_query_column_order = /** @type {((inputs?: Ledger_Query_Column_OrderInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Query_Column_OrderInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_query_column_order(inputs)
	return en_ledger_query_column_order(inputs)
});